<template>
  <button class="atc-form-close-button" @click.stop="$emit('click')">
    <div class="close-icon-wrapper">
      <div class="close-icon"></div>
      <div class="close-icon"></div>
    </div>
  </button>
</template>

<script>

export default {
  components: {
  },
};
</script>

<style lang="scss" scoped>
.atc-form-close-button {
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: none;
  height: 40px;
  width: 40px;
  z-index: 1001;
  padding: 10px;
  cursor: pointer;


  &::after {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
  }
}

.close-icon-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.close-icon {
  width: 15px;
  height: 2px;
  background-color: #c4c4c4;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}

.close-icon:nth-child(2) {
  transform: translate(-50%, -50%) rotate(-45deg);
}
</style>
